import { render, staticRenderFns } from "./paycheck-periods.vue?vue&type=template&id=10e2471c&scoped=true&"
import script from "./paycheck-periods.vue?vue&type=script&lang=ts&"
export * from "./paycheck-periods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2471c",
  null
  
)

export default component.exports